import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedSecurity: JSON.parse(localStorage.getItem("selectedSecurity")) || null,
  defaultSecurity: "",
};

const securitySlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    setSelectedSecurity(state, action) {
      state.selectedSecurity = action.payload;
      localStorage.setItem("selectedSecurity", JSON.stringify(action.payload));
    },
    setMainDefaultSecurity(state, action) {
      state.mainDefaultSecurity = action.payload;
    },
    setSecurityBarDetail(state, action) {
      state.securityBarDetails = action.payload;
      localStorage.setItem("securityBarDetails", JSON.stringify(action.payload));
    },
    setIndexBarDetail(state, action) {
      state.indexBarDetails = action.payload;
      localStorage.setItem("indexBarDetails", JSON.stringify(action.payload));
    },
    setPageReturn(state, action) {
      state.pageReturn = action.payload;
      localStorage.setItem("pageReturn", JSON.stringify(action.payload));
    },
  },
});

export const { setSelectedSecurity, setMainDefaultSecurity, setSecurityBarDetail, setPageReturn, setIndexBarDetail } = securitySlice.actions;
export default securitySlice.reducer;
